// extracted by mini-css-extract-plugin
export var browseMoreNav = "blog-post-preview-list-module--browseMoreNav--oPdnq";
export var grid = "blog-post-preview-list-module--grid--apvyE";
export var headline = "blog-post-preview-list-module--headline--qJ5eg";
export var root = "blog-post-preview-list-module--root--mkBgz";